import { useRef, useState } from "react";
import { Reveal } from "./Reveal";
import { CONFIG } from "../i18n";
import { trackEvent } from "../analytics";

const Contact = ({ t }) => {
  const formRef = useRef(null);
  const [notice, setNotice] = useState("");
  const [error, setError] = useState(false);
  const F = t.form;

  const readForm = () => {
    const f = formRef.current, d = {};
    ["name", "business", "what"].forEach((k) => (d[k] = f.elements[k]?.value || ""));
    ["need", "goal", "site", "when"].forEach((k) => {
      const r = f.querySelector(`input[name="${k}"]:checked`);
      d[k] = r ? r.value : "";
    });
    return d;
  };

  const buildMessage = (d) => {
    const opt = (k, arr) => (d[k] !== "" ? arr[+d[k]] : "—");
    return [
      F.msgIntro, "",
      `${F.name}: ${d.name.trim() || "—"}`,
      `${F.business}: ${d.business.trim() || "—"}`,
      `${F.what} ${d.what.trim() || "—"}`,
      `${F.need} ${opt("need", F.needOpts)}`,
      `${F.goal} ${opt("goal", F.goalOpts)}`,
      `${F.site} ${opt("site", F.siteOpts)}`,
      `${F.when} ${opt("when", F.whenOpts)}`,
    ].join("\n");
  };

  const submit = (channel) => {
    const d = readForm();
    if (!d.name.trim() || d.need === "") {
      setError(true);
      return;
    }
    setError("");
    // Lead del formulario (WhatsApp o correo). No dispara "whatsapp_click": ese es solo para enlaces <a>.
    trackEvent("generate_lead", { metodo: channel === "email" ? "correo" : "whatsapp" }, "Lead");
    const msg = buildMessage(d);
    if (channel === "whatsapp" && CONFIG.whatsapp) {
      window.open(`https://wa.me/${CONFIG.whatsapp.replace(/\D/g, "")}?text=${encodeURIComponent(msg)}`, "_blank", "noopener");
      return;
    }
    if (channel === "email" && CONFIG.email) {
      window.location.href = `mailto:${CONFIG.email}?subject=${encodeURIComponent(`${F.subject} — ${d.business.trim() || d.name.trim()}`)}&body=${encodeURIComponent(msg)}`;
      return;
    }
    setNotice(msg);
  };

  const chips = (name, opts) => (
    <div className="chips">
      {opts.map((o, i) => (
        <label className="chip" key={i}>
          <input type="radio" name={name} value={String(i)} data-testid={`chip-${name}-${i + 1}`} />
          <span>{o}</span>
        </label>
      ))}
    </div>
  );

  return (
    <section className="contact grain" id="contact" data-testid="contact-section">
      <div className="contact-head">
        <Reveal>
          <p className="eyebrow lt">{t.contactLabel}</p>
          <h2 className="lt">{t.contactTitle}</h2>
          <p className="contact-text lt-2">{t.contactText}</p>
        </Reveal>
      </div>
      <Reveal delay={0.1}>
        <form ref={formRef} className="brief" noValidate onSubmit={(e) => { e.preventDefault(); submit("whatsapp"); }} data-testid="contact-form">
          <div className="row2">
            <div className="field">
              <label htmlFor="f-name">{F.name}</label>
              <input id="f-name" name="name" type="text" autoComplete="name" data-testid="input-name" />
            </div>
            <div className="field">
              <label htmlFor="f-business">{F.business}</label>
              <input id="f-business" name="business" type="text" autoComplete="organization" data-testid="input-business" />
            </div>
          </div>
          <div className="field">
            <label htmlFor="f-what">{F.what}</label>
            <input id="f-what" name="what" type="text" placeholder={F.whatPh} data-testid="input-activity" />
          </div>
          <fieldset data-testid="fieldset-need">
            <legend>{F.need}</legend>
            {chips("need", F.needOpts)}
          </fieldset>
          <fieldset data-testid="fieldset-goal">
            <legend>{F.goal}</legend>
            {chips("goal", F.goalOpts)}
          </fieldset>
          <fieldset data-testid="fieldset-site">
            <legend>{F.site}</legend>
            {chips("site", F.siteOpts)}
          </fieldset>
          <fieldset data-testid="fieldset-when">
            <legend>{F.when}</legend>
            {chips("when", F.whenOpts)}
          </fieldset>
          <p className="form-error" role="alert" hidden={!error} data-testid="form-error">{error ? F.required : ""}</p>
          <div className="actions form-actions">
            <button type="submit" className="btn-gold" data-testid="btn-send-whatsapp">
              {F.send} <span className="arr">↗</span>
            </button>
            <button type="button" className="textlink lt" onClick={() => submit("email")} data-testid="btn-send-email">
              {F.sendEmail}
            </button>
          </div>
          <small className="contact-note lt-2">{t.contactNote}</small>
          {notice && (
            <div className="notice" role="status" data-testid="contact-notice">
              <p>{F.pending}</p>
              <pre>{notice}</pre>
            </div>
          )}
        </form>
      </Reveal>
    </section>
  );
};

export default Contact;
